export default __webpack_public_path__ + "static/media/battle_win.764065b2.jpg";